import { type ReactNode, createContext, useContext, useMemo } from "react";
import type { useDRMP } from "./logics";

const Context = createContext<ReturnType<typeof useDRMP> | undefined>(undefined);

export const useDRMPContext = () => {
  const context = useContext(Context);
  if (context === undefined) {
    throw new Error("useDRMPContext must be within DRMPProvider");
  }

  return context;
};

type IDRMP = ReturnType<typeof useDRMP> & {
  children: ReactNode;
};

export const DRMPProvider = ({ children, ...props }: IDRMP) => {
  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  const value = useMemo(
    () => props,
    [
      props.yearRange,
      props.setYearRange,
      props.selectRange,
      props.handleMouseEnter,
      props.handleMouseLeave,
      props.handleSelect,
      props.isSelected,
      props.isBetween,
    ]
  );

  return <Context.Provider value={value}>{children}</Context.Provider>;
};
